<template>
  <div>
    <div v-for="invoice in invoicesData" :key="invoice.id" class="box-print">
      <table class="h-80 w-80">
        <tr>
          <td :colspan="3">
            <p style="font-size: 14px">
              آدرس فرستنده: خیابان انقلاب، خیابان 12 فروردین، پلاک 284، کد پستی:
              1314674756
            </p>
            <p style="font-size: 14px">تلفن: 02188647654</p>
          </td>
        </tr>
        <tr>
          <td :colspan="2">تلفن: {{ invoice.shopCustomerMobile }}</td>
          <td :rowspan="7" style="text-align: center">
            <img
              style="width: 100px"
              src="../../../../assets/images/site-logo.png"
              alt=""
            />
            <br />
            فروشگاه اینترنتی کتاب بازار
            <br />
            https://ketabbaazar.ir
          </td>
        </tr>
        <tr>
          <td :colspan="2">
            تاریخ سفارش: {{ invoice.date }} - {{ invoice.time }}
          </td>
        </tr>
        <tr>
          <td :colspan="2">آدرس گیرنده: {{ invoice.addressForReceipt }}</td>
        </tr>
        <tr>
          <td :colspan="2">نام خریدار: {{ invoice.shopCustomerName }}</td>
        </tr>
        <tr>
          <td :colspan="2">کد پستی: {{ invoice.shopCustomerPostalCode }}</td>
        </tr>
        <tr>
          <td>روش پرداخت و خرید: {{ invoice.type }}</td>
          <td>مبلغ کل فاکتور: {{ invoice.totalPayablePrice }}</td>
        </tr>
        <tr>
          <td>کد سفارش: {{ invoice.code }}</td>
          <td>تاریخ چاپ رسید {{ currentDate }}</td>
        </tr>
        <tr>
          <td :colspan="3">
            لیست محصولات خریداری شده:
            <ul>
              <li v-for="(item, index) in invoice.details" :key="item.index">
                ({{ index + 1 }}) {{ item.name }}: {{ item.amount }} عدد /
                {{ Number(item.price * item.amount).toLocaleString() }} ریال
              </li>
            </ul>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import moment from "moment-jalaali";

export default {
  name: "MultiPreviewShop",
  data() {
    return {
      invoicesData: [],
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD HH:mm"),
    };
  },
  methods: {
    getInfo(ids) {
      const requests = ids.map((id) =>
        Axios.post(
          this.baseUrl + "/satrapp/shop/sales/getInfo/",
          {
            shopInvoiceId: id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              return res.data;
            } else {
              return null;
            }
          })
          .catch((err) => {
            return null;
          })
      );

      Promise.all(requests).then((results) => {
        this.invoicesData = results.filter((data) => data !== null);
        setTimeout(() => {
          window.print();
        }, 1000);
      });
    },
  },
  mounted() {
    const ids = this.$route.params.ids.split(",");
    this.getInfo(ids);
  },
};
</script>
<style lang="scss">
.box-print {
  background-color: #fff;
  width: 100%;
  table {
    width: 100%;
    border-collapse: collapse;
    tr {
      td {
        font-size: 14px;
        line-height: 1rem;
        padding: 10px;
        border: 1px solid black;
      }
    }
  }

  ul {
    list-style: none;
    padding: 0;
  }

  @media print {
    @page {
      margin: 0;
      size: A4 landscape;
      font-size: 40%;
      color: #000;
    }

    body {
      margin: 1.6cm;
    }

    .box-print {
      page-break-after: always;
    }

    .noPrint {
      display: none !important;
    }

    table,
    th,
    td {
      border: 1px solid black;
      border-collapse: collapse;
    }
  }
}
</style>
